import React from 'react'
import { HelmetProvider } from 'react-helmet-async'

export const wrapRootElement = ({ element }) => (
  <HelmetProvider>{element}</HelmetProvider>
)

export const onRouteUpdate = (_) => {
  if (process.env.NODE_ENV === `production`) {
    setTimeout(() => {
      if (typeof acalltracker !== 'undefined') {
        acalltracker.dynamicPageload()
      }
    }, 50)
  }
}
